<template>
  <div class="pt-2" style="background-color: white; max-height:90vh;overflow:hidden auto;">
    <div class="container-md px-3 border pb-3">
      <Profile :applicant-id="id" :isReviewer="isReviewer" :hide-new-tab="true" :isMaxHeight="true"/>
    </div>
  </div>
</template>

<script>
import Profile from "../components/dashboard/applicants/profile/Profile";
import {mapGetters} from "vuex"
export default {
  name: "ViewApplicantProfile",
  components: {Profile},
  props: ["id"],
  computed:{
    ...mapGetters({
      isReviewer: 'isCreateReviewUser'
    })
  },
  mounted() {
    this.changeBodyBackground();
  }
}
</script>

<style scoped>

</style>